import { farmDcDistributionOptions, fileUploadColumn, grandTotalFields, interDcDistributionOptions, regionalDistributionOptions, shippingDistributionOptions, unitInputColumn, valueInputColumn } from './columns'

// --- Flights and Accommodation Columns ---

export const flightsAndAccommodationColumns = [
    {
        label: 'Flight Type',
        field: 'flightType',
        type: 'select',
        options: [
            { id: 0, value: 'International One Way' },
            { id: 1, value: 'International Return' },
            { id: 2, value: 'Domestic One Way' },
            { id: 3, value: 'Domestic Return' },
            { id: 4, value: 'N/A' }
        ],
        selectLabel: 'Select Flight Type'
    },
    {
        label: 'Hotel Stays',
        field: 'hotelStays',
        type: 'select',
        options: [
            { id: 0, value: '0' },
            { id: 1, value: 1 },
            { id: 2, value: 2 },
            { id: 3, value: 3 },
            { id: 4, value: 4 },
            { id: 5, value: 5 },
            { id: 6, value: 6 },
            { id: 7, value: 7 },
            { id: 8, value: 8 },
            { id: 9, value: 9 },
            { id: 10, value: 10 },
        ],
        selectLabel: 'Select Duration',
    },
    {
        label: 'Number of Travellers',
        field: 'numberOfTravellers',
        type: 'select',
        options: [
            { id: 1, value: 1 },
            { id: 2, value: 2 },
            { id: 3, value: 3 },
            { id: 4, value: 4 },
            { id: 5, value: 5 },
            { id: 6, value: 6 },
            { id: 7, value: 7 },
            { id: 8, value: 8 },
            { id: 9, value: 9 },
            { id: 10, value: 10 },
        ],
        selectLabel: 'Travellers'
    },
    {
        ...valueInputColumn,
        label: 'Value (kg CO2)'
    },
    fileUploadColumn,
]

// --- Flights and Accommodation Totals ---
export const flightsAndAccommodationTotalColumns = [
    { label: 'Month', field: 'month' },
    { label: 'Total (kgCO2e)', field: 'total' }]

export const flightsAndAccommodationGrandTotalFields = grandTotalFields.kilograms

// --- Car Hire Columns ---

export const carHireColumns = [
    {
        label: 'Fuel Type',
        field: 'vehicleType',
        type: 'select',
        options: [
            { id: 0, value: 'Diesel' },
            { id: 0, value: 'Petrol' }
        ],
        selectLabel: 'Select Fuel Type',
    },
    {
        ...unitInputColumn,
        options: [
            { id: 0, value: 'Kilometers' }
        ],
    },
    valueInputColumn,
    fileUploadColumn,
]

// --- Car Hire Totals ---

export const carHireTotalColumns = [
    { label: 'Month', field: 'month' },
    { label: 'Total Diesel (km)', field: 'dieselQuantity' },
    { label: 'Total Petrol (km)', field: 'petrolQuantity' }
]

export const carHireGrandTotalFields = [
    { label: 'Grand Total', field: 'month' },
    { label: 'Grand Total Diesel (km)', field: 'grand_total_diesel' },
    { label: 'Grand Total Petrol (km)', field: 'grand_total_petrol' },
]

// --- Petrol Cards Columns --- 

export const petrolCardsColumns = (assetData) => [
    {
        label: 'Vehicle Registration',
        field: 'vehicleRegistration',
        type: 'select',
        options:
            assetData && assetData.length > 0
                ?
                assetData?.map((asset) => {
                    return { id: asset.id, value: asset.vehicleRegistration }
                }) :
                [{ id: 0, value: 'No Vehicle Registrations available' }],
        selectLabel: 'Select Vehicle Registration',
        isBackendData: true
    },
    {
        label: 'Card Holder',
        field: 'cardHolder',
        type: 'text',
        value: '',
        disabled: true
    },
    {
        label: 'Fuel Type',
        field: 'fuelType',
        type: 'select',
        options: [
            { id: 0, value: 'Diesel' },
            { id: 1, value: 'Petrol' }
        ],
        selectLabel: 'Select Fuel Type',
    },
    {
        ...unitInputColumn,
        options: [
            { id: 0, value: 'Kilometers' }
        ],
    },
    valueInputColumn,
    fileUploadColumn,
]


// --- Petrol Cards Totals ---

export const petrolCardsTotalColumns = [
    { label: 'Month', field: 'month' },
    { label: 'Total Diesel (km)', field: 'dieselQuantity' },
    { label: 'Total Petrol (km)', field: 'petrolQuantity' }
]

export const petrolCardsGrandTotalFields = [
    { label: 'Grand Total', field: 'month' },
    { label: 'Grand Total Diesel (km)', field: 'grand_total_diesel' },
    { label: 'Grand Total Petrol (km)', field: 'grand_total_petrol' }
]

// --- Downstream Distribution Columns ---

// --- Distribution Columns ---

// farm-dc and regional distribution share the same column structure

export const interDcDistributionColumns = [
    {
        label: 'Transport Company/Driver',
        field: 'companyOrDriver',
        type: 'text',
        placeholder: 'Transport'
    },
    {
        label: 'Transport Type',
        field: 'transportType',
        type: 'select',
        options: interDcDistributionOptions,
        selectLabel: 'Select Type'
    },
    {
        label: 'Destination',
        field: 'destination',
        type: 'text',
        placeholder: 'Destination',
    },
    {
        label: 'Distance (km)',
        field: 'distributionLength',
        type: 'text',
        placeholder: 'Distance'
    },
    {
        label: 'Load Weight (tonnes)',
        field: 'distributionLoadWeight',
        type: 'text',
        placeholder: 'Weight'
    },
    fileUploadColumn,
]

export const farmDcDistributionColumns = [
    {
        label: 'Transport Company/Driver',
        field: 'companyOrDriver',
        type: 'text',
        placeholder: 'Transport'
    },
    {
        label: 'Transport Type',
        field: 'transportType',
        type: 'select',
        options: farmDcDistributionOptions,
        selectLabel: 'Select Type'
    },
    {
        label: 'Destination',
        field: 'destination',
        type: 'text',
        placeholder: 'Destination',
    },
    {
        label: 'Distance (km)',
        field: 'distributionLength',
        type: 'text',
        placeholder: 'Distance'
    },
    {
        label: 'Load Weight (tonnes)',
        field: 'distributionLoadWeight',
        type: 'text',
        placeholder: 'Weight'
    },
    fileUploadColumn,
]

export const shippingDistributionColumns = [
    {
        label: 'Transport Company/Driver',
        field: 'companyOrDriver',
        type: 'text',
        placeholder: 'Transport'
    },
    {
        label: 'Transport Type',
        field: 'transportType',
        type: 'select',
        options: shippingDistributionOptions,
        selectLabel: 'Select Type'
    },
    {
        label: 'Destination',
        field: 'destination',
        type: 'text',
        placeholder: 'Destination',
    },
    {
        label: 'Distance (km)',
        field: 'distributionLength',
        type: 'text',
        placeholder: 'Distance'
    },
    {
        label: 'Load Weight (tonnes)',
        field: 'distributionLoadWeight',
        type: 'text',
        placeholder: 'Weight'
    },
    fileUploadColumn,
]

export const regionalDistributionColumns = [
    {
        label: 'Transport Company/Driver',
        field: 'companyOrDriver',
        type: 'text',
        placeholder: 'Transport'
    },
    {
        label: 'Transport Type',
        field: 'transportType',
        type: 'select',
        options: regionalDistributionOptions,
        selectLabel: 'Select Type'
    },
    {
        label: 'Destination',
        field: 'destination',
        type: 'text',
        placeholder: 'Destination',
    },
    {
        label: 'Distance (km)',
        field: 'distributionLength',
        type: 'text',
        placeholder: 'Distance'
    },
    {
        label: 'Load Weight (tonnes)',
        field: 'distributionLoadWeight',
        type: 'text',
        placeholder: 'Weight'
    },
    fileUploadColumn,
]



// --- Distribution Totals ---

export const distributionTotalColumns = [
    { label: 'Month', field: 'month' },
    { label: 'Total tonne.km', field: 'distributionQuantity' },
]
export const distributionGrandTotalFields = [
    { label: 'Grand Total', field: 'month' },
    { label: 'Grand Total Distribution Quantity', field: 'grand_total_distribution_quantity' }
]